import { useTranslation } from 'react-i18next';
import { formatCents } from '@/lib/format';
import {
  describeCampaignCpmRates,
  type CampaignCpmRatesInput,
} from '@/lib/campaigns/describeCampaignCpmRates';

type Props = {
  campaign: CampaignCpmRatesInput & { currency: string };
};

/** The rate note above a clipper's submissions table on /campaigns/:id. */
export function CampaignSubmissionsRateNote({ campaign }: Props) {
  const { t } = useTranslation();
  const rates = describeCampaignCpmRates(campaign);
  return (
    <span className="text-xs text-muted-foreground">
      {rates.kind === 'per_platform'
        ? t('campaign.submissions.calculatedAtPerPlatform')
        : t('campaign.submissions.calculatedAt', { rate: formatCents(rates.rateCents, campaign.currency) })}
    </span>
  );
}
